import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
 
import PageTopTitle from "../../components/shared/PageTopTitle";
import styled from "styled-components";
import Button from "../../components/shared/button/Btn";

import Pagination from "../../components/shared/Pagination";
import { showModal } from "../../features/modal/modalSlice";
import { getKiralikAracArayanFirmalar } from "../../features/ilanlar/ilanlarSlice";
import InputNewAracTypeSelect from "../../components/shared/input/new/InputNewAracTypeSelect";
import { AdminAracEkleOptions } from "../../utils/adminAracEkleOptions";
import InputSelectCity from "../../components/shared/input/new/InputSelectCity";
import InputSelect from "../../components/shared/input/new/InputSelect";
import KiralikAracArayanFirmalarContainer from "../../components/ilanlarContainers/KiralikAracArayanFirmalarContainer";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    .content {
      gap: 60px;
      margin: 0 30px;
      margin-top: 20px;
      @media (max-width: 1550px) {
        margin: 0;
        margin-top: 0;
        padding: 20px 30px 0px;
        overflow: auto;
      }
      .titles {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
          p{
            text-align: center;
            width: 120px;
          }
        }
      .btn-group {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 20px;
      }

      .filter-container {
        width: 100%;
        height: auto;
        /* border: 1px solid;
          border-color: ${({ theme }) => theme.mainBorderColor}; */
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0;
        @media (max-width: 1550px) {
          button {
            margin-left: 10px;
            width: 15%;
          }
        }
        @media (max-width: 1200px) {
          button {
            margin-left: 10px;
            width: 13%;
          }
        }

        .filter-input-grp {
          margin: 0 2px;
          display: flex;
          gap: 20px;
          @media (max-width: 1550px) {
            width: 85%;
            gap: 10px;

            .drowdown {
              width: 100%;
            }
          }
          @media (max-width: 1200px) {
            width: 85%;
            gap: 10px;

            .drowdown {
              width: 100%;
            }
          }
        }
      }
    }
  }
`;
const KiralikAracArayanFirmalar = () => {
  const dispatch = useDispatch();

  const [vehicleType, setVehicleType] = useState("");
  const [workCity, setWorkCity] = useState("");
  const [isAdvertiserCompany, setIsAdvertiserCompany] = useState({text: "Tümü", id: 0});

  const { kiralikAracArayanFirmalarList, kiralikAracFirmaCount } = useSelector((state) => state.ilanlar);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(kiralikAracFirmaCount / itemsPerPage);

  useEffect(() => {
    dispatch(getKiralikAracArayanFirmalar({workCity: vehicleType, vehicleType: vehicleType, isAdvertiserCompany: isAdvertiserCompany?.id, page: currentPage}));
  }, [workCity, vehicleType, isAdvertiserCompany, currentPage]);

  const titles = [
    "İlan No",
    "Kayıt Tarihi",
    "Araç Sayısı",
    "Araç Türü",
    "Kasa Tipi",
    "Çalışılacak İl",
    "Güzergah",
    "Yakıt Yüzdesi",
    "Kira Bedeli",
    "Kiralama Süresi(Ay)",
    "İlanı Veren Firma",
  ];

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Kiralık Araç Arayanlar"} position="sticky" />
        <div className="content">
          <div className="filter-container">
            <div className="filter-input-grp">
              <InputNewAracTypeSelect data={vehicleType} setData={setVehicleType} name={"arac"} labelText={"Araç Türü"} initialOptions={AdminAracEkleOptions} />
              <InputSelectCity data={workCity?.value} setData={setWorkCity} name={"workCity"} labelText={"Çalışılacak İl"} />
              <InputSelect data={isAdvertiserCompany.text} setData={setIsAdvertiserCompany} name={"isAdvertiserCompany"} labelText={"İlanlar"} initialOptions={[{text: "Tümü", id: 0}, {text: "İlanlarım", id: 1}, {text: "Diğer İlanlar", id: 2}]} />
            </div>
              <Button
                type="button"
                background={"#fff"}
                color={"#E85546"}
                handleClick={() => dispatch(showModal("addRentalCarSeekers"))}
                padding="0 10px"
                width="160px"
              >
              İlan Ekle
              </Button>
          </div>
          <div className="titles">
              {titles.map((item) => (
                <p>{item}</p>
              ))}
          </div>
          {kiralikAracArayanFirmalarList?.map((item)=>(
            <KiralikAracArayanFirmalarContainer data={item} />
          ))}

{(kiralikAracArayanFirmalarList && kiralikAracArayanFirmalarList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
          {/* <Table
            titles={titles}
            data={kiralikAraclar}
            type={"kiralikAracArayanlar"}
            eventQuantity={1}
          /> */}
          {/* {(kiralikAracArayanFirmalarList || kiralikAracArayanFirmalarList?.length > 0) && (
            <Pagination
              totalPages={totalPages}
              handleClick={setCurrentPage}
              currentPage={currentPage}
            />
          )} */}
        </div>
      </div>
    </Container>
  );
};

export default KiralikAracArayanFirmalar;
